import EligibilityWizard from "@/components/EligibilityWizard";
import { ShieldCheck, Clock, Sparkles } from "lucide-react";

const trust = [
  { icon: Clock, label: "2 minutes" },
  { icon: ShieldCheck, label: "Confidentiel" },
  { icon: Sparkles, label: "Gratuit" },
];

export default function Eligibility() {
  return (
    <div data-testid="eligibility-page" className="bg-[#F8FAFC]">
      <section className="relative overflow-hidden bg-[#0A0F1A] text-white">
        <div className="absolute inset-0 bg-grid-soft opacity-[0.06] pointer-events-none" />
        <div className="absolute -top-32 -right-32 h-[480px] w-[480px] rounded-full bg-[#10B981]/18 blur-3xl" />
        <div className="relative max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10 pt-40 md:pt-48 pb-20 md:pb-28 text-center">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Audit énergétique gratuit</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold tracking-[-0.025em] text-balance leading-[1.02]">
            Découvrez les CEE auxquels vous avez droit.
          </h1>
          <p className="mt-7 text-base md:text-xl text-white/75 max-w-2xl mx-auto leading-relaxed">
            Trois questions rapides, et un chargé d&apos;affaires ECONATION vous envoie une analyse
            d&apos;éligibilité complète sous 48 heures.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3 text-sm">
            {trust.map((t) => (
              <span key={t.label} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/8 backdrop-blur-md border border-white/15 text-white/85">
                <t.icon className="h-4 w-4 text-[#10B981]" /> {t.label}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20 md:-mt-24 relative z-10">
          <EligibilityWizard />
        </div>
      </section>
    </div>
  );
}
